import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { EmployeeInfoService } from '../services/employee-info.service';


export const employeeInfoResolver: ResolveFn<any> = () => {
  let employeeInfoService = inject(EmployeeInfoService);

  let http = inject(HttpClient);
  if (employeeInfoService.getEmployeeInfo() == null) {
    return http.get('/Employee/GetInfo')
      .toPromise()
      .then((response) => {
        employeeInfoService.setEmployeeInfo(response);
        var employeeInfo = employeeInfoService.getEmployeeInfo();
      });
  }
}
